"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFinleyAiThreadWithPromptResponses = exports.isFinleyAiThread = exports.isFinleyAiPromptResponse = exports.isFinleyAiTextractSupportedFileExtension = exports.isFinleyAiExtractValuesSupportedFileExtension = exports.isFinleyAiRequest = void 0;
const lodash_1 = __importDefault(require("lodash"));
const schema = __importStar(require("../schema"));
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isFinleyAiRequest = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiRequestSchema,
    typeguardName: 'isFinleyAiRequest',
});
exports.isFinleyAiExtractValuesSupportedFileExtension = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiExtractValuesSupportedFileExtensionSchema,
    typeguardName: 'isFinleyAiExtractValuesSupportedFileExtension',
});
exports.isFinleyAiTextractSupportedFileExtension = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiTextractSupportedFileExtensionSchema,
    typeguardName: 'isFinleyAiTextractSupportedFileExtension',
});
const _isFinleyAiPromptResponse = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiPromptResponseSchema,
    typeguardName: 'isFinleyAiPromptResponse',
});
const _isFinleyAiThread = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiThreadSchema,
    typeguardName: 'isFinleyAiThread',
});
const _isFinleyAiThreadWithPromptResponses = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinleyAiThreadWithPromptResponsesSchema,
    typeguardName: '_isFinleyAiThreadWithPromptResponses',
});
const isFinleyAiPromptResponse = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiPromptResponse',
        logInputs,
    })) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
    };
    return _isFinleyAiPromptResponse(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiPromptResponse = isFinleyAiPromptResponse;
const isFinleyAiThread = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiThread',
        logInputs,
    })) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
    };
    return _isFinleyAiThread(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiThread = isFinleyAiThread;
const isFinleyAiThreadWithPromptResponses = (obj, logInputs) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'FinleyAiThreadWithPromptResponses',
        logInputs,
    })) {
        return false;
    }
    if (!('promptResponses' in obj)) {
        if (logInputs && logInputs.logger) {
            logInputs.logger({
                message: `Expected FinleyAiThreadWithPromptResponses to contain property promptResponses.`,
            }, logInputs.logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    if (!Array.isArray(obj.promptResponses)) {
        if (logInputs && logInputs.logger) {
            logInputs.logger({
                message: `Expected FinleyAiThreadWithPromptResponses promptResponses to be typeof Array.`,
            }, logInputs.logLevel ?? Log_1.LogLevel.Error);
        }
        return false;
    }
    if (!lodash_1.default.every(obj.promptResponses, (pr) => (0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj: pr,
        typeName: 'FinleyAiThreadWithPromptResponses',
        logInputs,
    }))) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
        // already safe to cast of Object[]
        promptResponses: obj.promptResponses.map((pr) => ({
            ...pr,
            created_at: obj.created_at.toISOString(),
            updated_at: obj.updated_at.toISOString(),
        })),
    };
    return _isFinleyAiThreadWithPromptResponses(stringifiedTimestamps, logInputs);
};
exports.isFinleyAiThreadWithPromptResponses = isFinleyAiThreadWithPromptResponses;
//# sourceMappingURL=finleyAi.js.map